import React from 'react';

import { selectAuthUiUrl } from 'util/selector/apiSelector';

import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { Dropdown } from 'component/Dropdown/Dropdown';
import { DropdownItem } from 'component/Dropdown/Dropdown.s';
import { FeatureFlags } from 'config/featureFlags';
import { UserLogoutWrapper } from 'view/TopBars/Header/Header.s';

export const AUTH_UI_SESSIONS_PATH = '/sessions';

export namespace UserLogout {
  export type Props = {
    userName: string;
    onLogout: () => void;
  };
}

export const UserLogout = (props: UserLogout.Props) => {
  const isActiveSessionsEnabled = useFeatureIsOn(FeatureFlags.ACTIVE_SESSIONS);

  const handleManageSessions = () => {
    window.location.assign(`${selectAuthUiUrl()}${AUTH_UI_SESSIONS_PATH}`);
  };

  return (
    <UserLogoutWrapper>
      <Dropdown data-testid="logout" label={props.userName}>
        {isActiveSessionsEnabled && (
          <DropdownItem data-testid="manageSessionsButton" onClick={handleManageSessions}>
            Manage sessions
          </DropdownItem>
        )}
        <DropdownItem data-testid="logoutButton" onClick={props.onLogout}>
          Log Out
        </DropdownItem>
      </Dropdown>
    </UserLogoutWrapper>
  );
};
